import { Rule } from './rule';

export class BingoCheatSheet {
  public static readonly allCheatSheets: Rule[] = [
    {
      title: 'components.cheat-sheet.bingo.header-1',
      body: [
        {
          type: 'text',
          content: 'components.cheat-sheet.bingo.body-1',
        },
      ],
    },
    {
      title: 'components.cheat-sheet.bingo.header-2',
      body: [
        { type: 'text', content: 'components.cheat-sheet.bingo.body-2a' },
        { type: 'text', content: 'components.cheat-sheet.bingo.body-2b' },
        { type: 'text', content: 'components.cheat-sheet.bingo.body-2c' },
        { type: 'text', content: 'components.cheat-sheet.bingo.body-2d' },
      ],
    },
    {
      title: 'components.cheat-sheet.bingo.header-3',
      body: [
        { type: 'text', content: 'components.cheat-sheet.bingo.body-3a' },
        { type: 'text', content: 'components.cheat-sheet.bingo.body-3b' },
        { type: 'text', content: 'components.cheat-sheet.bingo.body-3c' },
        { type: 'text', content: 'components.cheat-sheet.bingo.body-3d' },
        { type: 'text', content: 'components.cheat-sheet.bingo.body-3e' },
      ],
    },
    {
      title: 'components.cheat-sheet.bingo.header-4',
      body: [
        { type: 'text', content: 'components.cheat-sheet.bingo.body-4a' },
        { type: 'text', content: 'components.cheat-sheet.bingo.body-4b' },
        { type: 'text', content: 'components.cheat-sheet.bingo.body-4c' },
        { type: 'text', content: 'components.cheat-sheet.bingo.body-4d' },
        { type: 'text', content: 'components.cheat-sheet.bingo.body-4e' },
        { type: 'text', content: 'components.cheat-sheet.bingo.body-4f' },
        { type: 'text', content: 'components.cheat-sheet.bingo.body-4g' },
      ],
    },
  ];
}
